import DashboardIndex from '../components/dashboard/Index.vue';

export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardIndex,
    meta: {
      requiresAuth: true,
      permissions: {
        Dashboard: ['*']
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/DashboardRoutes.js